import { render, staticRenderFns } from "./filter-options.vue?vue&type=template&id=2270d4b0&"
import script from "./filter-options.vue?vue&type=script&lang=js&"
export * from "./filter-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports